export const NUMBER_OF_MINUTES_IN_HOUR = 60;
